import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import listing from '../api/listing';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

// Initial state
const state = {
    error: '',
    loading: false,
    listing: [],
    resource: '', // API URL for specific page listing
    specification: {},
    filterCount: 0,
    selectedFilters: [],
    facets: [],
    pagination: {
        pageIndex: 0,
        pageSize: 0,
        rowEnd: 0,
        rowStart: 0,
        total: 0,
        totalPages: 0
    },
    initState: {}
};

// Getters
const getters = {
    getField
};

// Actions
const actions = {
    setQuery({ commit }, query) {
        commit('updateQuery', query);
    },
    updateError({ commit }, error) {
        commit('updateError', error);
    },
    updateLoading({ commit }, loading) {
        commit('updateLoading', loading);
    },
    setFilter({ commit }) {
        listing.setFilter(data => {
            commit('setListing', data);
        }, {
            specification: state.specification,
            resource: state.resource
        });
    },
    setPeopleProfileFilter({ commit }) {
        listing.setFilter(data => {
            commit('setPeopleProfileListing', data);
        }, {
            specification: state.specification,
            resource: state.resource
        });
    }
};

// Mutations
const mutations = {
    updateField,
    updateQuery(state, query) {
        state.specification.Query = query;
    },
    updateError(state, error) {
        state.error = error;
    },
    updateLoading(state, loading) {
        state.loading = loading;
    },
    setInitData(state, result) {
        state.initState = result;
        state.selectedFilters = [{ spec: '', value: 'Clear All' }];
        state.listing = result.Items;
        state.facets = result.Facets != null ? result.Facets[0].Values : [];
        state.specification = { ...state.initState.Specification };        

        state.pagination = {
            pageIndex: result.PageIndex + 1,
            pageSize: result.PageSize,
            rowEnd: result.RowEnd,
            rowStart: result.RowStart,
            total: result.Total,
            totalPages: result.TotalPages
        };
    },
    setResource(state, resource) {
        state.resource = resource;
    },
    updateSpecification(state, {
        key,
        value,
        manualSearch
    }) {
        // Update the specification object
        for (const [specKey, specValue] of Object.entries(state.specification)) {
            if (key === specKey && value != null) {
                state.specification[key] = value;
            }
        }

        // Reset pagination on any filter change
        if (key !== 'PageIndex') {
            state.specification.PageIndex = 0;
            state.pagination.pageIndex = 1;
            if (state.specification.Skip !== undefined) {
                state.specification.Skip = 0;
            }
        } else {
            state.pagination.pageIndex = value + 1;
        }

        if (key === 'PageIndex' && value === 0) {
            if (state.specification.Skip !== undefined) {
                state.specification.Skip = 0;
            }
        }

        if (key === 'Sort' && state.specification.Skip !== undefined) {
            state.specification.Skip = 0;
        }

        if (manualSearch) return;

        if (window.history.pushState) {
            const encodeDataToURL = (data) => {
                const value = Object.keys(data)
                .map((key) => `${key}=${encodeURIComponent(data[key])}`)
                .join('&');
                return value;
            };
            const removeEmpty = (obj) => {
                const newObj = [];
                Object.keys(obj).forEach((key) => {
                    if (obj[key] && typeof obj[key] === 'object') {
                        newObj[key] = removeEmpty(obj[key]);
                    } else if (obj[key] !== null && obj[key] !== '' && obj[key] !== '999') {
                        newObj[key] = obj[key];
                    }
                });
                return newObj;
            };

            const specification = removeEmpty(state.specification);
            let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${encodeDataToURL(specification)}`;
            window.history.pushState({ path: newurl }, '', newurl);
        }
    },
	navigateToUrl(state) {
		if (window.history.pushState) {
            const encodeDataToURL = (data) => Object.keys(data)
                .map((key) => `${key}=${encodeURIComponent(data[key])}`)
                .join('&');

			const removeEmpty = (obj) => {
				const newObj = {};
				Object.keys(obj).forEach((key) => {
					if (obj[key] && typeof obj[key] === 'object') {
						newObj[key] = removeEmpty(obj[key]);
					} else if (obj[key] !== null && obj[key] !== '') {
						if (obj[key] !== '999') {
							newObj[key] = obj[key];
						}
					}
				});
				return newObj;
			};

			const specification = removeEmpty(state.specification);
			let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${encodeDataToURL(specification)}`;
			window.history.pushState({ path: newUrl }, '', newUrl);
		}
	},
	resetSpecification(state) {
        state.listing = state.initState.Items;
        state.facets = [];
        state.specification = state.initState.Specification;
        state.pagination = { ...state.initState };
        state.filterCount = 0;
        state.selectedFilters = [{ spec: '', value: 'Clear All' }];


        const newUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
    },
    setListing(state, data) {
        if (data === undefined) return;
        state.listing = data.Items;
        state.specification = data.Specification;
        state.pagination = {
            pageIndex: data.PageIndex + 1,
            pageSize: data.PageSize,
            rowEnd: data.RowEnd,
            rowStart: data.RowStart,
            total: data.Total,
            totalPages: data.TotalPages
        };
    },
    setPeopleProfileListing(state, data) {
        state.listing = [...state.listing, ...data.Items];
        state.specification = data.Specification;
        state.pagination = {
            pageIndex: data.PageIndex + 1,
            pageSize: data.PageSize,
            rowEnd: data.RowEnd,
            rowStart: data.RowStart,
            total: data.Total,
            totalPages: data.TotalPages
        };
    },
    addNewTagFilter(state, data) {  
          if (!Array.isArray(state.selectedFilters)) {
            state.selectedFilters = [data];
          }

          if (!Object.hasOwn(data, 'value')) {
            return;
          }

          const keyValue = data.value;
          const existingObjects = state.selectedFilters.filter(item => typeof item === 'object' && item !== null && Object.hasOwn(item, 'value') && item.value === keyValue);
          if (existingObjects.length > 0) {
            state.selectedFilters = state.selectedFilters.filter(item => !(typeof item === 'object' && item !== null && Object.hasOwn(item, 'value') && item.value === keyValue));
          } else {
            state.selectedFilters = [...state.selectedFilters, data];
          }          
    },
    removeTagFilter(state, data) {
          if (!Array.isArray(state.selectedFilters)) {
            state.selectedFilters = [data];
          }

          if (!Object.hasOwn(data, 'value')) {
            return;
          }

          const keyValue = data.value;
          if (keyValue === 'Clear All') {
              this.commit('listing/resetSpecification');
              return;
          }
          const existingObjects = state.selectedFilters.filter(item => typeof item === 'object' && item !== null && Object.hasOwn(item, 'value') && item.value === keyValue);

          if (existingObjects.length > 0) {
            state.selectedFilters = state.selectedFilters.filter(item => !(typeof item === 'object' && item !== null && Object.hasOwn(item, 'value') && item.value === keyValue));
          }
    },
    clearTagBySpecification(state, data) {
        if (!Array.isArray(state.selectedFilters) || data == null) return;

        // Normalize incoming data to array of lowercase spec names
        const specs = (Array.isArray(data) ? data : [data])
            .filter(s => s != null)
            .map(s => String(s).trim().toLowerCase())
            .filter(s => s !== '');

        if (specs.length === 0) return;

        state.selectedFilters = state.selectedFilters.filter(item => {
            // keep items that are not objects or without a spec property
            if (!item || typeof item !== 'object' || !Object.prototype.hasOwnProperty.call(item, 'spec')) {
                return true;
            }
            const itemSpec = item.spec == null ? '' : String(item.spec).toLowerCase();
            // remove item when its spec matches any of the specs to clear
            return !specs.includes(itemSpec);
        });

        // Ensure "Clear All" remains as the first filter
        if (!state.selectedFilters.some(f => f && f.value === 'Clear All')) {
            state.selectedFilters.unshift({ spec: '', value: 'Clear All' });
        }
    }
};

// Vuex Store
export default new Vuex.Store({
    modules: {
        listing: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    },
    strict: debug
});
